import { SignUpUserInfoNextActionEventContexts } from './sign-up-user-info-next-actions.types';

export const userInfoEventContext: Readonly<Record<string, SignUpUserInfoNextActionEventContexts>> = {
  New: 'New',
  Existing: 'Existing',
  DomainCheck: 'Domain Check',
};
